<template>
  <div>
    <v-layout wrap>
      <v-flex >
        <c-search-form
            :rows-per-page-items="[10, 20, 50]"
            :form-name="formName"
            :fields="fields"
            :hiddenFields="hiddenFields"
            model="searchForm"
            key-property="accountId"
            search-url="/notify/listAllBundle"
            create-url="/notify/saveBundle"
            form-type="intable"
            custom-create-new
            @createNew="openCreateDialog"
            custom-edit-item
            @editItem="openCreateDialog"
            custom-class-item
            @classItem="openClassDialog"
            ref="tableData"
            :reload="timeReload"
            :deleteMulti="false"
            orderBy="desc"
            :acceptDelete="false"
            :acceptView="false"
            :accept-edit="true"
            :accept-create="true"
        >
        </c-search-form>
        <material-type-group-create
            :propsItem="category"
            :cDialog="visibleCreateDialog"
            @closeCreateDialog="closeCreateDialog"
            :formCreateName="formCreateName"
            :hiddenFields="hiddenFields"
        />
      </v-flex>
    </v-layout>
  </div>

</template>

<script>
import CSearchForm from "../../../components/form/ManageForm";
import {areaContants} from "@/constants";
import axios from "axios";
import MaterialTypeGroupCreate from "@/views/admin/notifyMKT/BundleCreate";

export default {
  name: "warehouse",
  components: {MaterialTypeGroupCreate, CSearchForm},
  data: () => {
    return {
      formName: "List bundle config",
      formCreateName: "",
      className: null,
      category: null,
      visibleCreateDialog: false,
      timeReload: 0,
      searchUrl:null,
      accountId:null,
      allAcount: 0,
      hiddenFields: {
        typeId: "0",
      },
      fields: [
        {
          value: "index",
          text: "No",
          width: "2%",
          sortable: false,
          headerStyle: "text-align:center",
        },
        {
          value: 'name',
          text: 'Name',
          search: true,
          width: "3%",
          sortable: false,
          headerStyle: "text-align:center",
        },
        {
          value: 'androidUrl',
          text: 'ANDROID_Url',
          sortable: false,
          search: false,
          width: "5%",
          headerStyle: "text-align:center",
        },
        {
          value: 'iosUrl',
          text: 'IOS_Url',
          sortable: false,
          search: false,
          width: "5%",
          headerStyle: "text-align:center",
        },
        {
          value: 'pcUrl',
          text: 'PC_Url',
          sortable: false,
          search: false,
          width: "5%",
          headerStyle: "text-align:center",
        },
        {
          value: 'version',
          text: 'Version',
          sortable: false,
          search: false,
          width: "2%",
          headerStyle: "text-align:center",
        },
        {
          value: "action",
          text: "lang.common.actions",
          sortable: false,
          compound: true,
          headerStyle: "text-align:center",
          width: "2%",
        },
      ],
    };
  },

  created() {
  },



  methods: {

    showImage(item) {
      window.open(item.imgBackground, '_blank').focus();
    },
    showImage1(item) {
      window.open(item.imgClose, '_blank').focus();
    },

    openLink(item) {
      var audio = new Audio(item.url);
      audio.play();
    },
    openLinkNewTap(item) {
      window.open(item.voicePath, '_blank', 'noreferrer');
    },

    openLinkimgBackground(item) {
      window.open(item.imgBackground, '_blank', 'noreferrer');
    },

    openCreateDialog: function (item = null) {
      if (item == null) {
        this.formCreateName = 'Add Bundle';
        this.getNextCode();
      } else {
        this.category = item;
        this.formCreateName = 'Update Popup ';
        this.visibleCreateDialog = true;
      }
    },
    closeCreateDialog: function () {
      this.category = null;
      this.visibleCreateDialog = false;
      this.timeReload = Math.floor(Math.random() * 100);
    },

    getNextCode: function () {
      axios.get(
          process.env.VUE_APP_API_URL +
          "/autoIncrease/getNextNumber?type=MATERIAL_TYPE_ALLY"
      )
          .then((data) => {
            this.category = Object.assign({}, this.category, {"categoryCode": "MATERIAL_TYPE_ALLY" + data, "status": 1})
            this.visibleCreateDialog = true;
          });
    },

    createParamLastSearch: function (values) {
      const obj1 = {
        searchImportRequest: JSON.stringify(values),
      };
      /*const obj2 = this.$route.query;*/
      const obj2 = this.$route.query;
      return {...obj1, ...obj2};
    },
    viewItem: function (item) {
      this.$router.push({
        path: '/accountDetail/view/' + item.accountId,
        //path: '/accountDetail/view/' + item.accountId,
        query: this.createParamLastSearch(this.lastSearchValues)
      });
    },
  },

  destroyed() {
  },
};
</script>
